import { Outlet } from 'react-router-dom'
import Sidebar from './sidebar'
import useIsCollapsed from '@/hooks/use-is-collapsed'
import SkipToMain from '../skip-to-main'
import Header from './header'
import { Suspense, useState } from 'react'
import { Loader } from '../custom/loader'
import { useNotificationListener } from '@/hooks/useNotificationListener'
import NavigationProgress from '../custom/navigation-progress'
import RouteParamsMemory from './route-params-memory'

export default function AppShell() {
  const [isCollapsed, setIsCollapsed] = useIsCollapsed()
  const [navOpened, setNavOpened] = useState(false)
  useNotificationListener()

  return (
    <div className='relative h-full overflow-hidden bg-background'>
      <NavigationProgress />
      <RouteParamsMemory />
      <SkipToMain />
      <Sidebar
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
        navOpened={navOpened}
        setNavOpened={setNavOpened}
      />
      <Header
        navOpened={navOpened}
        onToggleNav={() => setNavOpened((prev) => !prev)}
      />
      <main
        id='content'
        className={`h-[calc(100svh-7rem)] overflow-x-hidden px-2.5 pt-3 transition-[margin] sm:px-7 md:h-[calc(100svh-var(--header-height))] md:pt-5 ${isCollapsed ? 'md:ml-14' : 'md:ml-64'}`}
      >
        <Suspense fallback={<Loader size='sm' />}>
          <Outlet />
        </Suspense>
      </main>
    </div>
  )
}
